export default __webpack_public_path__ + "static/media/bag.db8545d5.png";